export enum SalesEnquiryStatus {
	Ongoing = 0,
	Won = 10,
	Lost = 20,
}